<template>
  <div class="request-home">
    <div class="video-container">
      <video id="video" autoplay loop muted>
        <source src="/dist/video/01_about.mp4" type="video/mp4">
        배경화면
      </video>
    </div>
    <div class="welcome-header"></div>
    <div class="welcome" style="z-index:2">
      <div class="box">
        <div class="box-content">
          <div class="ncp-logo">
          </div>
          <p class="welcome-title1">출입신청조회</p>
          <br/>
          <br/>
          <p>
            과거 1년동안의 입실 내역 및 출입신청 내역을 조회합니다.
          </p>
          <br/>
          <br/>
          <div class="box-row">
            <div class="box-label">이름</div>
            <!--<input type="text" class="box-input" v-model="item.empName"/>-->
            <input type="text" class="box-input" v-model="item.visitorName"/>
          </div>
          <div class="box-row">
            <div class="box-label">이메일</div>
            <!--<input type="text" class="box-input" v-model="item.empEmail"/>-->
            <input type="text" class="box-input" v-model="item.visitorEmail"/>
          </div>
        </div>
        <div class="box-bottom" >
          <div class="lang"><i class="icon-global"></i></div>
          <a class="btn lg white point" @click="goToRequestLookup()">확인</a>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import Vuex from 'vuex';
Vue.use(Vuex);
export default {
  name: "Request",
  components: {
  },
  data(){
    return {
      item: {},
      isShow: true
    }
  },
  mounted(){
    this.isShow = true;

  },
  methods: {
    goToRequestLookup(){
      if(this.item.visitorName == null) {
        this.noti("입력 정보 확인", "이름 입력 후 검색", "warning");
        return ;
      }
      if(this.item.visitorEmail == null) {
        this.noti("입력 정보 확인", "이메일 입력 후 검색", "warning");
        return;
      }

      this.$router.push({name: 'requestLookup', query: this.item});
    },
    // getAuth(){
    //   var payloadString = $.param(this.item);
    //   var that = this;
    //   this.$http.get('/api/public/emp/auth'+'?'+ payloadString)
    //     .then((result) => {
    //       that.$store.dispatch('auth/setAuth', result.data.token);
    //       that.getCurrentEmployee();
    //       that.$toast.success(that.$t('message.welcome1'));
    //       that.$router.push({ path: '/app/main/'})
    //
    //     }).catch((e) =>{
    //       console.log(e);
    //
    //       that.$toast.error(that.$t('error.visitError'));
    //   })
    // },
    // getCurrentEmployee(){
    //   var that = this;
    //   this.$http.get('/api/private/emp/currentEmployee')
    //     .then((result) => {
    //       that.$store.dispatch('auth/setEmployee', result.data);
    //
    //     }).catch((e) =>{
    //       console.log(e);
    //   })
    // }
  }
};
</script>
